import ReminderModal from "./ReminderModal";
import RepeatModal from "./RepeatModal";

const CheckBoxModals = {
    ReminderModal,
    RepeatModal
}

export { CheckBoxModals };